          <template>
    <v-card class="transparent stickytopconscious" width="100%" height="100%">
    <!-- <v-card class="transparent"> -->
      <!-- <div  class="my-10"> -->
        <v-card class="transparent" width="100%" flat>
            <v-parallax
            height="150"
            src="@/assets/Tribunes_Parallax_(Invert).jpeg"
            >
              
              <v-row
              align="center"
              justify="center"
            >
              <v-col class="parallaxbgcontentgrad text-center" cols="12">
                <h1 class="display-2 font-weight-thin mb-4">Financial</h1>
                <h4 class="headline">FREEDOM</h4>
              </v-col>
            </v-row>
            </v-parallax>            
            </v-card>
            <!-- </div>-->
      <!-- <div  class="my-10"> -->
        <v-card color="#FFFFFF" width="100%" flat>
            <v-layout row wrap class="justify-center mx-3">
                <v-flex lg8 md9 sm8 xs12 class="mx-2">
                    <h2 class="primary--text mx-1 my-3" align="center">Rehabilitation</h2>          
                <div>This process is another High court order issued, to overrule the Sequestration order and restore an insolvent's name.</div><div><br></div><div>After the Sequestration process was successfully concluded "and all claims against your estate was settled by your curator in terms of the insolvency law", the insolvent may apply for early rehabilitation.</div><div><br></div><div>"Depending on circumstance, you can rehabilitate as early as twelve months after date of sequestration."</div><div><br></div><div>The process itself that takes round about 2 - 3 months, providing the necessary information and consent was given by the curator.</div><div><br></div><div>The rehabilitation order may the be sent to all credit bureau's&nbsp; to gain ITC clearance.</div><div><br></div><div>Once the above mentioned was done, you may then be able to incur new debt again should you wish to.&nbsp;</div><div><br></div><div>For more information, contact us, or submit an application</div><br><br>
                </v-flex>
                </v-layout>            
            </v-card>
            <!-- </div>-->
      <!-- <div  class="my-10"> -->
        <v-card class="transparent" width="100%" flat>
        <v-img src="@/assets/Helping_Hand.jpeg"  width="100%" height="300">
            <v-layout row wrap class="justify-center mx-3">
                <v-flex lg8 md9 sm8 xs12 class="mx-2">
                </v-flex>
                </v-layout>
        </v-img>            
            </v-card>
            <!-- </div>-->
            
        </v-card> 
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'


export default {
  name: 'Rehabilitation',
  metaInfo: {
    title: 'Rehabilitation Service - Tribunes SA',
    meta: [
      {
        name: 'description',
        content: `Restore your financial standing with early rehabilitation after sequestration. Obtain ITC clearance within 2-3 months and regain the ability to incur new debt. Contact us for details.`
      },
      {
        name: 'keywords',
        content: 'Rehabilitation, Debt, Tribunes SA'
      }
    ]
  },
    components: {
        },
    data() {
    return {      
      UserRecord: {},
      rules: {
        youtubeurl: value => {
            const pattern = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
            return pattern.test(value) || "Not a Youtube Video Link.";
          },
          min8Chars: value => value.length >= 8 || "Min. 8 characters",
          required: value => !!value || "Required.",
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          },
          url: value => {
            const urlpattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); 
            return urlpattern.test(value) || "Invalid Link.";
          }
        },
    }
    },
    computed:{
      userLoggedIn () {
      return this.$store.getters.user
    },
      
      

    },
    mounted () {
  window.scrollTo(0, 0)
},
    created(){
      this.FocusedViewToggle()
      this.IntranetViewToggle()
      this.CheckUser()

    },
    
    methods: {
      IntranetViewToggle(){
        this.$emit('IntranetViewToggle',false)
      },
      FocusedViewToggle(){
        this.$emit('FocusedViewToggle',false)
      },
      async CheckUser(){
            let vm = this
            await firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                  db.collection('users').doc(user.uid).onSnapshot(snapshot => {
              var userdetails = snapshot.data()

              vm.UserRecord = userdetails
              vm.UserRecord.id = user.uid
              console.log(vm.UserRecord)
                  })
                }
                else{
                }
            })
        },
          DateFormatter(date){
            if(date){
            let yearstring = date.split('-')[0]
              let monthstring = date.split('-')[1]
              let daystring = date.split('-')[2]
              let yearnumber = Number(yearstring)
              let monthnumber = Number(monthstring)
              let daynumber = Number(daystring)
              return new Date(yearnumber, monthnumber-1, daynumber)
              }
            else{
              return null
            }
          },

    }    
}
</script>

<style>
.parallaxbgcontentgrad {
  background-image: linear-gradient(to right, rgba(20,26,31,0.5), rgb(189,199,209, 1));
}
.transoutline{
    border: 1px solid black;
    background-color:pink
    /* color: rgba(255,255,255,0.05) */
}
.v-card--reveal {
    /* background-color: rgba(176, 7, 255, 0.5); */
  background-color: rgba(255, 193, 7, 0.75);
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
  z-index:10
}

.iconoutline{
  text-shadow: 0 0 3px #FF0000;
}
</style>

        
            
        